import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box
} from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {PropTypes} from 'prop-types';
 
export default function DateTimePickerDialog({
  open,
  onClose,
  onConfirm,
  loading,
  value,
  onChange,
  title = "Schedule Deployment",
  label = "Schedule Time"
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
       <DialogTitle sx={{ fontSize: '18px', fontWeight: 'Bold'}}>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label={label}
              value={value}
              onChange={onChange}
              sx={{ width: '100%' }}
              viewRenderers={{
                hours: null,
                minutes: null,
                seconds: null,
              }}
               slotProps={{
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 2], // Move popover down a bit (optional)
          },
        },
      ],
      sx: {
        '& .MuiPaper-root': {
        //   maxHeight: 240, // Or any value you prefer
          overflowY: 'auto',
        //   maxWidth:400,
         width:400,
        height: 240
 
        }
      }
    }
  }}
              // You can customize more props as needed!
            />
          </LocalizationProvider>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
          Schedule
        </Button>
      </DialogActions>
    </Dialog>
  );
}
DateTimePickerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  value: PropTypes.any, 
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
};
 